export const STORAGE_MAX_FTL_CARGO_WEIGHT = 43000;
